import axios from "axios";

const AxiosClient = axios.create();

export function setupAxiosToken(token) {
    AxiosClient.defaults.headers.common['X-Authorization'] = token;
}
export function setupXUserId(xUserId) {
    AxiosClient.defaults.headers.common['X-UserId'] = xUserId;
}
export default AxiosClient;


// WEBPACK FOOTER //
// ./src/_helpers/http.helper.js